import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'

import { QA_NAME_PREVIEW_CLOSE_SPLIT } from './MultipleViewTypeListActiveItemPreviewCloseButton.constants'

import CloseIcon from '../../../icons/close.svg'

function MultipleViewTypeListActiveItemPreviewCloseButton({
  height = BUTTON_HEIGHT_32,
  onClose,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <Button.Flat
      {...restProps}
      isGrey
      beforeIconProps={{ Icon: CloseIcon }}
      height={height}
      qaName={QA_NAME_PREVIEW_CLOSE_SPLIT}
      tooltip={t('Table.PreviewCloseSplitViewBtnKey')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={onClose}
    />
  )
}

export default MultipleViewTypeListActiveItemPreviewCloseButton
